var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAfternoon = function SvgAfternoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    "aria-hidden": "true",
    className: "iconify iconify--twemoji",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M14 2s0-2 2-2 2 2 2 2v2s0 2-2 2-2-2-2-2zm16 12s2 0 2 2-2 2-2 2h-2s-2 0-2-2 2-2 2-2zM4 14s2 0 2 2-2 2-2 2H2s-2 0-2-2 2-2 2-2zm3.872-7.957s1.414 1.414 0 2.828-2.828 0-2.828 0L3.629 7.458s-1.414-1.414 0-2.829c1.415-1.414 2.829 0 2.829 0zm19.085 2.828s-1.414 1.414-2.828 0 0-2.828 0-2.828l1.414-1.414s1.414-1.414 2.828 0 0 2.828 0 2.828z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 9,
    fill: "#FFAC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M28 20c-.825 0-1.62.125-2.369.357A6.5 6.5 0 0 0 19.5 16c-3.044 0-5.592 2.096-6.299 4.921A4.46 4.46 0 0 0 10.5 20 4.5 4.5 0 0 0 6 24.5c0 .604.123 1.178.339 1.704A5 5 0 0 0 5 26c-2.762 0-5 2.238-5 5s2.238 5 5 5h23a8 8 0 1 0 0-16"
  })));
};
export { SvgAfternoon as ReactComponent };
export default __webpack_public_path__ + "d57d28c6f588c5476af8b19aa2c3a20d.svg";